import { IMFormModal } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const FormContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  margin-bottom: 5rem;
`;

export const InputSectionStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 3rem;
`;

export const IMFormModalStyled = styled(IMFormModal)`
  max-width: 70rem;
`;
